import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Page3Mobile = ({ sectionStyle }) => {
  const navigate = useNavigate();
  const bgImg = `
    <svg width="351" height="370" viewBox="0 0 351 370" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_243_514)">
<rect width="351" height="370" rx="30" fill="#0D8ED1"/>
<g opacity="0.5" filter="url(#filter0_f_243_514)">
<circle cx="176.5" cy="482.5" r="108.5" fill="#005FDA"/>
</g>
<g opacity="0.6" clip-path="url(#clip1_243_514)">
<mask id="mask0_243_514" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="-93" y="0" width="1440" height="1440">
<rect width="1440" height="1197" transform="translate(-93)" fill="url(#paint0_radial_243_514)"/>
</mask>
<g mask="url(#mask0_243_514)">
<g clip-path="url(#clip2_243_514)">
<mask id="path-5-inside-1_243_514" fill="white">
<path d="M-45 0H51V96H-45V0Z"/>
</mask>
<path d="M51 96V97H52V96H51ZM51 0H50V96H51H52V0H51ZM51 96V95H-45V96V97H51V96Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-5-inside-1_243_514)"/>
<mask id="path-7-inside-2_243_514" fill="white">
<path d="M51 0H147V96H51V0Z"/>
</mask>
<path d="M147 96V97H148V96H147ZM147 0H146V96H147H148V0H147ZM147 96V95H51V96V97H147V96Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-7-inside-2_243_514)"/>
<mask id="path-9-inside-3_243_514" fill="white">
<path d="M147 0H243V96H147V0Z"/>
</mask>
<path d="M243 96V97H244V96H243ZM243 0H242V96H243H244V0H243ZM243 96V95H147V96V97H243V96Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-9-inside-3_243_514)"/>
<mask id="path-11-inside-4_243_514" fill="white">
<path d="M243 0H339V96H243V0Z"/>
</mask>
<path d="M339 96V97H340V96H339ZM339 0H338V96H339H340V0H339ZM339 96V95H243V96V97H339V96Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-11-inside-4_243_514)"/>
<mask id="path-13-inside-5_243_514" fill="white">
<path d="M339 0H435V96H339V0Z"/>
</mask>
<path d="M435 96V97H436V96H435ZM435 0H434V96H435H436V0H435ZM435 96V95H339V96V97H435V96Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-13-inside-5_243_514)"/>
<mask id="path-15-inside-6_243_514" fill="white">
<path d="M-45 96H51V192H-45V96Z"/>
</mask>
<path d="M51 192V193H52V192H51ZM51 96H50V192H51H52V96H51ZM51 192V191H-45V192V193H51V192Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-15-inside-6_243_514)"/>
<mask id="path-17-inside-7_243_514" fill="white">
<path d="M51 96H147V192H51V96Z"/>
</mask>
<path d="M147 192V193H148V192H147ZM147 96H146V192H147H148V96H147ZM147 192V191H51V192V193H147V192Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-17-inside-7_243_514)"/>
<mask id="path-19-inside-8_243_514" fill="white">
<path d="M147 96H243V192H147V96Z"/>
</mask>
<path d="M147 96H243V192H147V96Z" fill="#F2F4F7" fill-opacity="0.1"/>
<path d="M243 192V193H244V192H243ZM243 96H242V192H243H244V96H243ZM243 192V191H147V192V193H243V192Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-19-inside-8_243_514)"/>
<mask id="path-21-inside-9_243_514" fill="white">
<path d="M243 96H339V192H243V96Z"/>
</mask>
<path d="M339 192V193H340V192H339ZM339 96H338V192H339H340V96H339ZM339 192V191H243V192V193H339V192Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-21-inside-9_243_514)"/>
<mask id="path-23-inside-10_243_514" fill="white">
<path d="M339 96H435V192H339V96Z"/>
</mask>
<path d="M435 192V193H436V192H435ZM435 96H434V192H435H436V96H435ZM435 192V191H339V192V193H435V192Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-23-inside-10_243_514)"/>
<mask id="path-25-inside-11_243_514" fill="white">
<path d="M-45 192H51V288H-45V192Z"/>
</mask>
<path d="M51 288V289H52V288H51ZM51 192H50V288H51H52V192H51ZM51 288V287H-45V288V289H51V288Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-25-inside-11_243_514)"/>
<mask id="path-27-inside-12_243_514" fill="white">
<path d="M51 192H147V288H51V192Z"/>
</mask>
<path d="M147 288V289H148V288H147ZM147 192H146V288H147H148V192H147ZM147 288V287H51V288V289H147V288Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-27-inside-12_243_514)"/>
<mask id="path-29-inside-13_243_514" fill="white">
<path d="M147 192H243V288H147V192Z"/>
</mask>
<path d="M243 288V289H244V288H243ZM243 192H242V288H243H244V192H243ZM243 288V287H147V288V289H243V288Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-29-inside-13_243_514)"/>
<mask id="path-31-inside-14_243_514" fill="white">
<path d="M243 192H339V288H243V192Z"/>
</mask>
<path d="M339 288V289H340V288H339ZM339 192H338V288H339H340V192H339ZM339 288V287H243V288V289H339V288Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-31-inside-14_243_514)"/>
<mask id="path-33-inside-15_243_514" fill="white">
<path d="M339 192H435V288H339V192Z"/>
</mask>
<path d="M339 192H435V288H339V192Z" fill="#F2F4F7" fill-opacity="0.1"/>
<path d="M435 288V289H436V288H435ZM435 192H434V288H435H436V192H435ZM435 288V287H339V288V289H435V288Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-33-inside-15_243_514)"/>
<mask id="path-35-inside-16_243_514" fill="white">
<path d="M-45 288H51V384H-45V288Z"/>
</mask>
<path d="M51 384V385H52V384H51ZM51 288H50V384H51H52V288H51ZM51 384V383H-45V384V385H51V384Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-35-inside-16_243_514)"/>
<mask id="path-37-inside-17_243_514" fill="white">
<path d="M51 288H147V384H51V288Z"/>
</mask>
<path d="M147 384V385H148V384H147ZM147 288H146V384H147H148V288H147ZM147 384V383H51V384V385H147V384Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-37-inside-17_243_514)"/>
<mask id="path-39-inside-18_243_514" fill="white">
<path d="M147 288H243V384H147V288Z"/>
</mask>
<path d="M243 384V385H244V384H243ZM243 288H242V384H243H244V288H243ZM243 384V383H147V384V385H243V384Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-39-inside-18_243_514)"/>
<mask id="path-41-inside-19_243_514" fill="white">
<path d="M243 288H339V384H243V288Z"/>
</mask>
<path d="M339 384V385H340V384H339ZM339 288H338V384H339H340V288H339ZM339 384V383H243V384V385H339V384Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-41-inside-19_243_514)"/>
<mask id="path-43-inside-20_243_514" fill="white">
<path d="M339 288H435V384H339V288Z"/>
</mask>
<path d="M435 384V385H436V384H435ZM435 288H434V384H435H436V288H435ZM435 384V383H339V384V385H435V384Z" fill="#D0D5DD" fill-opacity="0.32" mask="url(#path-43-inside-20_243_514)"/>
</g>
<rect x="-332.5" y="0.5" width="1919" height="1439" stroke="#D0D5DD" stroke-opacity="0.32"/>
</g>
</g>
</g>
<defs>
<filter id="filter0_f_243_514" x="-332" y="-26" width="1017" height="1017" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="200" result="effect1_foregroundBlur_243_514"/>
</filter>
<radialGradient id="paint0_radial_243_514" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(720 -0.000142694) rotate(90) scale(1197 751.588)">
<stop/>
<stop offset="0.953125" stop-opacity="0"/>
</radialGradient>
<clipPath id="clip0_243_514">
<rect width="351" height="370" rx="30" fill="white"/>
</clipPath>
<clipPath id="clip1_243_514">
<rect width="1247" height="480" fill="white" transform="translate(3)"/>
</clipPath>
<clipPath id="clip2_243_514">
<rect x="-333" width="1920" height="1440" fill="white"/>
</clipPath>
</defs>
</svg>

  `;
  const encodedSvg = encodeURIComponent(bgImg.trim());
  return (
    <div
      style={{
        ...sectionStyle,
        gap: "10px",
        position: "relative",
        height: "100vh",
      }}
      className="d-flex flex-column justify-content-around align-items-center"
    >
      <div
        className="w-100 d-flex flex-column align-items-center justify-content-center"
        style={{
          position: "relative",
          height: "45vh",
          backgroundImage: `url("data:image/svg+xml,${encodedSvg}")`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          borderRadius: "32px",
        }}
      >
        <div
          style={{
            width: "100%",
            gap: "10px",
          }}
          className="d-flex flex-column justify-content-center align-items-center text-center"
        >
          <div style={{ fontSize: "34px", fontWeight: "700", color: "white" }}>
            Social Shopping Made Easy
          </div>
          <div
            className="px-4"
            style={{ fontSize: "16px", fontWeight: "400", color: "#FFFFFFCC" }}
          >
            Enjoy seamless navigation, exclusive content, and personalized
            experiences right at your fingertips. Don't miss out on this
            opportunity to enhance.
          </div>
          <div
            style={{
              marginTop: "18px",
              width: "248px",
              height: "53px",
              backgroundColor: "white",
              color: "#0D8ED1",
              cursor: "pointer",
            }}
            className="d-flex justify-content-center align-items-center rounded-pill"
            onClick={() => navigate("/SignIn")}
          >
            Explore Lookflock
          </div>
        </div>
      </div>
      <div
        className="d-flex flex-column align-items-center py-4"
        style={{ gap: "20px" }}
      >
        <div
          style={{ gap: "14px" }}
          className="d-flex flex-column align-items-center text-center"
        >
          <div
            style={{
              fontFamily: "Nunito Sans",
              fontWeight: "600",
              fontSize: "40px",
              lineHeight: "100%",
              letterSpacing: "0%",
              fontStyle: "italic",
              color: "#676A79",
            }}
          >
            lookflock
          </div>
          <div
            style={{ fontSize: "16px", fontWeight: "400", color: "#676A79" }}
          >
            Lookflock is a social shopping platform where you can discover
            trending outfits, and create collaborative shopping lists.
          </div>
        </div>
        <div style={{ width: "100%", border: "1.5px solid #17171714" }} />
        <div className="d-flex align-items-center" style={{ gap: "23px" }}>
          <Link
            style={{ color: "#676A79", textDecoration: "underline" }}
            to="/staticPages/privacyPolicy"
          >
            Privacy Policy
          </Link>
          <Link
            style={{ color: "#676A79", textDecoration: "underline" }}
            to="/staticPages/termsAndConditions"
          >
            Terms of Service
          </Link>
          <Link
            style={{ color: "#676A79", textDecoration: "underline" }}
            to="/staticPages/contactUs"
          >
            Contact Support
          </Link>
        </div>
        <div
          className="w-100 text-center"
          style={{ color: "#676A79", fontSize: "15px", fontWeight: "400" }}
        >
          Copyright © 2025 Lookflock. All Rights Reserved
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          height: "55%",
          width: "100%",
          backgroundColor: "#F3F3F3",
          zIndex: "-1",
          bottom: 0,
        }}
      />
    </div>
  );
};

export default Page3Mobile;
